import { render, staticRenderFns } from "./br-date-picker.vue?vue&type=template&id=65578a6c"
import script from "./br-date-picker.vue?vue&type=script&lang=js"
export * from "./br-date-picker.vue?vue&type=script&lang=js"
import style0 from "./br-date-picker.vue?vue&type=style&index=0&id=65578a6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports